/**
 * La voix d'un participant (pur) : quel appareil du participant parle, et par quelle piste.
 *
 * Une vignette du live est celle d'une personne (son id), et une personne peut être là sur plusieurs
 * appareils (`<id>.<appareil>`, la même identité que pour sa vidéo, `tracksOfParticipant`). Sa voix
 * est celle de l'appareil dont le micro est ouvert ; aucun micro ouvert, pas de voix.
 */
import { userIdOfIdentity } from "./dataChannel"

export type VoiceCandidate<P> = {
    participant: P
    identity: string
    /** Le micro publié et ouvert. */
    micOn: boolean
}

/** L'appareil de `personId` dont le micro est ouvert, sinon rien. */
export function voiceOf<P>(candidates: readonly VoiceCandidate<P>[], personId: string): P | null {
    if (personId === "") return null
    const own = candidates.filter((candidate) => userIdOfIdentity(candidate.identity) === personId)
    return own.find((candidate) => candidate.micOn)?.participant ?? null
}
